import Loadable from 'react-loadable';

import PleaseWait from '~/components/loaders/please-wait';

export default Loadable({
  loader: () =>
    import(/* webpackChunkName: "llamasoft", webpackPrefetch: true */ './Llamasoft.tsx'),
  loading: () => <PleaseWait />,
});
